import { action, makeAutoObservable } from "mobx";

export class ScheduleStore {
  selectedDate = "";

  selectedTime = "08:00";

  isLoading = false;

  error: string | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  @action
  setSelectedDate(date: string) {
    this.selectedDate = date;
    this.error = null;
  }

  @action
  setSelectedTime(time: string) {
    this.selectedTime = time;
    this.error = null;
  }

  @action
  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

  @action
  setError(error: string | null) {
    this.error = error;
  }

  get isValid() {
    return Boolean(this.selectedDate && this.selectedTime);
  }

  get formattedDate() {
    if (!this.selectedDate) return "";
    const date = new Date(this.selectedDate);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  scheduleSetups() {
    // TODO: Implement schedule setups functionality
    this.setLoading(true);
    // Implementation will use this.selectedDate and this.selectedTime
    // When implemented, this will make API calls using the selected values
    this.setLoading(false);
  }
}

export default new ScheduleStore();
